import React, { useState, useEffect } from "react";
import { useHistory, useLocation, useParams } from "react-router-dom";
import { Modal, Button, Select, Input, Table, Form } from "antd";
import { Icon } from "@iconify/react";
import axios from "axios";
import { checkPropTypes } from "prop-types";

interface Props {
  // show?: boolean;
  dataReturn: (data: any) => void;
  // type: string;
  // path?: string;
}

const ModalJobGroups: React.FC<Props> = ({ dataReturn }) => {
  const navigate = useHistory();
  const [isModalVisible, setIsModalVisible] = useState<boolean>(false);
  const [isDisable, setIsDisable] = useState<boolean>(false);
  const [list, setList] = useState<any>([]);
  const [sum, setSum] = useState<any>([]);
  const [sumDiscount, setSumDisCount] = useState<any>([]);

  const [dataJobTitle, setDataJobTitle] = useState<any>([]);

  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const colums = [
    {
      title: "",
      dataIndex: "row",
      align: "center" as const,
      width: "5%",
    },
    {
      title: "Job Title",
      dataIndex: "name",
      width: "20%",
    },
    {
      title: "ค่ามือ/Com (Bath 1Hr)",
      dataIndex: "handFeeCom1Hr",
      align: "right" as const,
      width: "17%",
    },
    {
      title: "ค่ามือ/Com (Bath 2Hr)",
      dataIndex: "handFeeCom2Hr",
      align: "right" as const,
      width: "17%",
    },
    {
      title: "ค่ามือ/Com (Bath 2Hr) ",
      dataIndex: "handFeeCom3Hr",
      align: "right" as const,
      width: "17%",
    },
    {
      title: "Action",
      dataIndex: "code",
      align: "center" as const,
      width: "6%",
      render: (data: any, record: any) => (
        <a onClick={() => addJobTitle(record)}>
          {/* {console.log("data", data)} */}
          <Icon
            icon="akar-icons:circle-plus-fill"
            width="1.2rem"
            height="1.2rem"
            style={{ color: "#4D7E7F" }}
          />
        </a>
      ),
    },
  ];

  const getJobTitle = () => {
    axios.get(`/job-titles?page=1`).then((res) => {
      let xData = res?.data?.data;
      // console.log("xdata=>>>>>>>>>", xData);

      let xDatas = xData.map((x: any, index1: number) => ({
        ...x,
        row: index1 + 1,
      }));
      setDataJobTitle(xDatas);
    });
  };

  const addJobTitle = (data: any) => {
    // console.log("values =>", values);
    // if (sum.length !== 0) {
    //   const filter = sum?.filter((x: any) => x.id !== values.id);
    //   if (filter.length !== 0) {
    //     setList(values);
    //   }
    // } else {
    //   setList(values);
    // }

    // console.log("data", data);

    handleCancel();
    dataReturn?.(data);
  };

  useEffect(() => {
    // if (list.length !== 0) {
    //   sum.push(list);
    //   console.log("list =>", list);
    //   console.log("sum =>", sum);
    // }
  }, [list]);

  useEffect(() => {
    getJobTitle();
  }, []);

  return (
    <div>
      <div className="btn-confirm">
        <Button type="primary" onClick={showModal}>
          Select Item
        </Button>
      </div>
      <div>
        <Modal
          visible={isModalVisible}
          onCancel={handleCancel}
          footer={null}
          className="modal-doctor"
        >
          <h3>เลือกรายการ/Select Item</h3>
          <div className="input-search">
            <Input.Search
              bordered={false}
              onSearch={(e) => {
                // setDataSearch({ ...dataSearch, search: e})
              }}
            />
          </div>

          <div style={{ marginTop: "20px" }} className="table-data">
            <Table
              columns={colums}
              dataSource={dataJobTitle}
              scroll={{ x: 100, y: 300 }}
              pagination={false}
              bordered
              rowKey="_id"
            />
          </div>
        </Modal>
      </div>
    </div>
  );
};
export default ModalJobGroups;
